import { render } from "./MenusTable.vue?vue&type=template&id=17c2e06b"
import script from "./MenusTable.vue?vue&type=script&lang=js"
export * from "./MenusTable.vue?vue&type=script&lang=js"

import "./MenusTable.vue?vue&type=style&index=0&id=17c2e06b&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__